// Module
var code = "<template>\n\n\n  <div slot=\"content\">\n\n    <iframe id=\"myiframe\" src=\"https://emissioninventory.airbkk.com/Client/#/Modules/EmissionInventory/EmissionMapGraphPublicBMAPage\" title=\"description\"  style=\" display: block; height: 200vh; width: 100vw; border: none; \"></iframe>\n  </div>\n</template>\n\n";
// Exports
export default code;